import { AppSettings } from '@/types'

const SETTINGS_KEY = 'invoice-dashboard-settings'

const DEFAULT_SETTINGS: AppSettings = {
  analyserOcrModels: ['mistralai/mistral-ocr-2501'],
  analyserExtractionModels: ['google/gemini-3.1-flash-lite'],
}

/**
 * Load settings from local storage
 */
export function loadSettings(): AppSettings {
  try {
    const stored = localStorage.getItem(SETTINGS_KEY)
    if (stored) {
      const parsed = JSON.parse(stored)
      return { ...DEFAULT_SETTINGS, ...parsed }
    }
  } catch (error) {
    console.error('Error loading settings:', error)
  }
  return DEFAULT_SETTINGS
}

/**
 * Save settings to local storage
 */
export function saveSettings(settings: Partial<AppSettings>): AppSettings {
  try {
    const current = loadSettings()
    const updated = { ...current, ...settings }
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(updated))
    return updated
  } catch (error) {
    console.error('Error saving settings:', error)
    return loadSettings()
  }
}

/**
 * Clear settings from local storage
 */
export function clearSettings(): void {
  try {
    localStorage.removeItem(SETTINGS_KEY)
  } catch (error) {
    console.error('Error clearing settings:', error)
  }
}
